import React from "react";
import "./LiveGames.css";

const GAMES = [
  {
    id: "115585557817319",
    title: "Smash Everything!",
    description:
      "Floor it through the city and smash everything. Jump, plow through buildings, grab the cash, and climb the leaderboard.",
    url: "https://www.roblox.com/games/115585557817319/Smash-Everything",
    image: "/images/games/smash-everything.png",
    gallery: [
      "/images/games/smash-everything-1.png",
      "/images/games/smash-everything-2.png",
      "/images/games/smash-everything-3.png",
      "/images/games/smash-everything-4.png",
    ],
  },
  {
    id: "132607471739756",
    title: "Ring Gunners - Bullet Hell",
    description:
      "Orbit the arena, blast waves of invaders, dodge bullet-hell bosses, and climb the global leaderboards.",
    url: "https://www.roblox.com/games/132607471739756/Ring-Gunners-Bullet-Hell",
    image: "/images/games/ring-gunners.png",
    gallery: [
      "/images/games/ring-gunners-1.png",
      "/images/games/ring-gunners-2.png",
      "/images/games/ring-gunners-3.png",
    ],
  },
  {
    id: "119778626217520",
    title: "Nova Grove - Cozy Skilling RPG",
    description:
      "Gather resources, level your skills, forge gear, and build your house on the frontier world of Nova.",
    url: "https://www.roblox.com/games/119778626217520/Nova-Grove-Cozy-Skilling-RPG",
    image: "/images/games/nova-grove.png",
    gallery: [
      "/images/games/nova-grove-1.png",
      "/images/games/nova-grove-2.png",
      "/images/games/nova-grove-3.png",
      "/images/games/nova-grove-4.png",
    ],
  },
];

export default function LiveGames() {
  return (
    <section className="live-games" aria-labelledby="live-games-heading">
      <div className="live-games__inner">
        <header className="live-games__header">
          <h1 id="live-games-heading" className="live-games__heading">
            Live now
          </h1>
          <p className="live-games__intro">
            Play my games on Roblox.
          </p>
        </header>
        <div className="live-games__grid">
          {GAMES.map((game) => (
            <a
              key={game.id}
              href={game.url}
              target="_blank"
              rel="noopener noreferrer"
              className="live-games__card"
            >
              <div className="live-games__thumb">
                <img src={game.image} alt="" />
              </div>
              {game.gallery?.length > 0 && (
                <ul className="live-games__gallery" aria-label={`${game.title} screenshots`}>
                  {game.gallery.map((src) => (
                    <li key={src} className="live-games__gallery-item">
                      <img src={src} alt="" loading="lazy" />
                    </li>
                  ))}
                </ul>
              )}
              <div className="live-games__body">
                <span className="live-games__status">[LIVE]</span>
                <h2 className="live-games__title">{game.title}</h2>
                <p className="live-games__desc">{game.description}</p>
                <span className="live-games__cta">Play on Roblox</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
